import React from "react";
import type { QuestionConfig } from "../questionConfig";
import { SingleSelect } from "./SingleSelect";
import { MultiSelect } from "./MultiSelect";
import { TextInput } from "./TextInput";

interface QuestionRendererProps {
  question: QuestionConfig;
  value: unknown;
  onChange: (value: unknown) => void;
}

export function QuestionRenderer({ question, value, onChange }: QuestionRendererProps) {
  switch (question.type) {
    case "single":
      return (
        <SingleSelect
          label={question.label}
          description={question.description}
          options={question.options || []}
          value={value as string | undefined}
          onChange={onChange}
          required={question.required}
        />
      );

    case "multi":
      return (
        <MultiSelect
          label={question.label}
          description={question.description}
          options={question.options || []}
          value={value as string[] | undefined}
          onChange={onChange}
          required={question.required}
          maxSelections={question.maxSelections}
        />
      );

    case "text":
      return (
        <TextInput
          label={question.label}
          description={question.description}
          placeholder={question.placeholder}
          value={value as string | undefined}
          onChange={onChange}
          required={question.required}
          multiline={false}
        />
      );

    case "textarea":
      return (
        <TextInput
          label={question.label}
          description={question.description}
          placeholder={question.placeholder}
          value={value as string | undefined}
          onChange={onChange}
          required={question.required}
          multiline={true}
        />
      );

    default:
      return null;
  }
}
